import { Trophy } from "lucide-react";
import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const SuccessPopup = ({ show, onHide, mode = "exercise" }) => {
	const handleHide = useCallback(() => {
		onHide();
	}, [onHide]);

	useEffect(() => {
		if (show) {
			const timer = setTimeout(() => {
				handleHide();
			}, 5000);

			return () => clearTimeout(timer);
		}
	}, [show, handleHide]);

	const title = mode === "program" ? "Program Complete!" : "Activity Complete!";
	const message =
		mode === "program"
			? "Another program completed. Keep up the amazing work!"
			: "Another activity completed. Keep up the amazing work!";

	return (
		<div
			className="position-fixed top-0 start-50 translate-middle-x mt-4"
			style={{
				zIndex: 9999,
				width: "90vw",
				maxWidth: "600px",
			}}
		>
			<ToastContainer>
				<Toast
					show={show}
					onClose={handleHide}
					autohide={false}
					className="border-0"
					style={{
						width: "100%",
						backgroundColor: "#fff",
						boxShadow: "0 4px 24px rgba(226, 46, 120, 0.15)",
						borderRadius: "12px",
					}}
				>
					<Toast.Header
						className="border-0 px-4 py-3 d-flex align-items-center"
						style={{
							background: "#e22e78",
							color: "white",
							borderTopLeftRadius: "12px",
							borderTopRightRadius: "12px",
						}}
					>
						<strong className="me-auto fs-4">{title}</strong>
					</Toast.Header>

					<Toast.Body className="text-center px-4 py-5">
						<div className="position-relative mb-4" style={{ height: "120px" }}>
							<div
								className="position-absolute top-50 start-50 translate-middle"
								style={{
									width: "120px",
									height: "120px",
									background: "#e22e78",
									borderRadius: "50%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Trophy size={60} color="white" />
							</div>
						</div>

						<h3 className="mb-3 fw-bold" style={{ color: "#2c3e50" }}>
							You&apos;re Absolutely Crushing It! 🌟
						</h3>

						<p className="mb-0 fs-5" style={{ color: "#34495e" }}>
							{message}
						</p>
					</Toast.Body>
				</Toast>
			</ToastContainer>
		</div>
	);
};

SuccessPopup.propTypes = {
	show: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired,
	mode: PropTypes.oneOf(["exercise", "program"]),
};

export default SuccessPopup;